module.exports = __webpack_public_path__ + "media/marketing_area/Vendors_Dynamic_Products_2-2fd950b8.jpg";